<template>
    <div class="product">
        <a :href="link" v-if="link != '#testimonials'">
            <div class="product__image" :style="{ backgroundImage: 'url(' + require(`../../assets/${image}.jpg`) + ')' }"></div>
            <span class="product__name">{{ name }}</span>
        </a>
        <a @click="scrollToElement" v-else>
            <div class="product__image" :style="{ backgroundImage: 'url(' + require(`../../assets/${image}.jpg`) + ')' }"></div>
            <span class="product__name">{{ name }}</span>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'Product',
        props: {
            image: String,
            name: String,
            link: String
        },
        methods: {
            scrollToElement() {
                const el = document.querySelector('#testimonials');
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth' });
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

    .product {
        width: 100%;
        border-radius: 5px;
        text-align: center;
        background-color: #fff;
        box-shadow: 0 0 14px -12px #9a9a9a;

        &__image {
            position: relative;
            width: 100%;
            height: 22rem;
            border-bottom: .5rem solid #fad2ca;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            background-color: #fff;
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
        }

        &__name {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            min-height: 11.2rem;
            padding: 3rem;
            text-decoration: none;
            text-transform: uppercase;
            font-family: 'Roboto Slab', sans-serif;
            font-size: 2rem;
            transition: color .15s ease-in-out;
        }

        a {
            text-decoration: none;

            &:hover,
            &:focus,
            &:active {

                .product__name {
                    color: #385dae;
                }
            }
        }
    }

    @media (max-width: 767px) {

        .product {

            &__image {
                height: 30rem;
            }
        }
    }

</style>